<template>
  <div class="detail-item" v-if="editingData && options">
    <div class="head"><b>雇用期間の定め</b></div>
    <div class="data">
      <p
        v-if="editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI || editingData.koyou_type == OptionConst.KOYOU_TYPE.PART_MUKI">
        無期</p>
      <p
        v-else-if="editingData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU || editingData.koyou_type == OptionConst.KOYOU_TYPE.JIKYUU || editingData.koyou_type == OptionConst.KOYOU_TYPE.PART">
        有期</p>

      <template v-if="currentData?.koyou_type">
        <p class="current-data"
          v-if="currentData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU_MUKI || currentData.koyou_type == OptionConst.KOYOU_TYPE.PART_MUKI">
          無期</p>
          <p class="current-data"
          v-else-if="currentData.koyou_type === OptionConst.KOYOU_TYPE.GEKKYUU || currentData.koyou_type == OptionConst.KOYOU_TYPE.JIKYUU || currentData.koyou_type == OptionConst.KOYOU_TYPE.PART">
          有期</p>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import OptionConst from '@/const/Option';
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
  },
  setup() {

    return {
      OptionConst,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
